import type { Product } from '~/types'

export function useQuickView() {
  const activeProduct = useState<Product | null>('quick-view-product', () => null)
  const isOpen = useState<boolean>('quick-view-open', () => false)

  function open(product: Product) {
    activeProduct.value = product
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return {
    activeProduct,
    isOpen,
    open,
    close,
  }
}
